import { orderBy as baseOrderBy } from "lodash";

export const orderBy = (arr, key = "id", order = "desc") => {
  if (arr.length === 0) return arr;
  return baseOrderBy(arr, [key], [order]);
};
